// Validation function outside the component

interface FieldsState {
  field1: string | null;
  field2: string | null;
  minValue: string;
  maxValue: string;
  minField: string | null;
  maxField: string | null;
}

const validatePayoutFields = (
  payoutType: string,
  fields: FieldsState
): Record<string, string> => {
  const errors: Record<string, string> = {};

  // Helper function to add error
  const addError = (fieldName: string, message: string) => {
    errors[fieldName] = message;
  };

  // Common validation for all types
  if (!payoutType) {
    addError('type', 'Payout type is required');
  }

  // Validation based on payout type
  switch (payoutType) {
    case 'percentage':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.field2) addError('field2', 'Field2 is required');
      break;

    case 'percentage_min_fixed_max_variable':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.field2) addError('field2', 'Field2 is required');
      if (!fields.minValue) addError('minValue', 'Minimum value is required');
      if (!fields.maxField) addError('maxField', 'Maximum field is required');
      break;

    case 'percentage_min_fixed_max_fixed':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.field2) addError('field2', 'Field2 is required');
      if (!fields.minValue) addError('minValue', 'Minimum value is required');
      if (!fields.maxValue) addError('maxValue', 'Maximum value is required');
      break;

    case 'percentage_min_variable_max_variable':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.field2) addError('field2', 'Field2 is required');
      if (!fields.minField) addError('minField', 'Minimum field is required');
      if (!fields.maxField) addError('maxField', 'Maximum field is required');
      break;

    case 'percentage_min_variable_max_fixed':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.field2) addError('field2', 'Field2 is required');
      if (!fields.minField) addError('minField', 'Minimum field is required');
      if (!fields.maxValue) addError('maxValue', 'Maximum value is required');
      break;

    case 'percentage_min_fixed':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.field2) addError('field2', 'Field2 is required');
      if (!fields.minValue) addError('minValue', 'Minimum value is required');
      break;

    case 'percentage_min_variable':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.field2) addError('field2', 'Field2 is required');
      if (!fields.minField) addError('minField', 'Minimum field is required');
      break;

    case 'percentage_max_fixed':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.field2) addError('field2', 'Field2 is required');
      if (!fields.maxValue) addError('maxValue', 'Maximum value is required');
      break;

    case 'percentage_max_variable':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.field2) addError('field2', 'Field2 is required');
      if (!fields.maxField) addError('maxField', 'Maximum field is required');
      break;

    case 'flat':
      if (!fields.field1) addError('field1', 'Field1 is required');
      break;

    case 'flat_min_variable_max_fixed':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.minField) addError('minField', 'Minimum field is required');
      if (!fields.maxValue) addError('maxValue', 'Maximum value is required');
      break;

    case 'flat_min_variable_max_variable':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.minField) addError('minField', 'Minimum field is required');
      if (!fields.maxField) addError('maxField', 'Maximum field is required');
      break;

    case 'flat_min_fixed_max_fixed':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.minValue) addError('minValue', 'Minimum value is required');
      if (!fields.maxValue) addError('maxValue', 'Maximum value is required');
      break;

    case 'flat_min_fixed_max_variable':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.minValue) addError('minValue', 'Minimum value is required');
      if (!fields.maxField) addError('maxField', 'Maximum field is required');
      break;

    case 'flat_max_fixed':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.maxValue) addError('maxValue', 'Maximum value is required');
      break;

    case 'flat_max_variable':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.maxField) addError('maxField', 'Maximum field is required');
      break;

    case 'flat_min_fixed':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.minValue) addError('minValue', 'Minimum value is required');
      break;

    case 'flat_min_variable':
      if (!fields.field1) addError('field1', 'Field1 is required');
      if (!fields.minField) addError('minField', 'Minimum field is required');
      break;

    default:
      break;
  }

  return errors;
};

export default validatePayoutFields;
